export var ASC = 'ASC';
export var DESC = 'DESC';
export var SMALL = 'small';
export var MEDIUM = 'medium';
export var LARGE = 'large';
export var XLARGE = 'xlarge';
export var LOADING_CONTENTS_OPACITY = 0.22;
//# sourceMappingURL=constants.js.map